import * as React from 'react';
import styles from './LinearProgress.module.scss';

const LinearProgress = ({
    percent,
    color = '#65CE8F',
    compact = false,
    trackColor,
}) => {

    return (
    <div className={`${styles.mainProgressBarDiv}${compact ? ` ${styles.compact}` : ''}`} >
            <div
                className={styles.emptyProgressBar}
                style={{
                    width: "100%",
                    ...(trackColor ? { backgroundColor: trackColor } : {}),
                }}
            >
                <div
                    className={styles.fillingProgressBar}
                    style={{
                        background: color,
                        width: `${Math.min(Math.max(percent, 0), 100)}%`,
                        transition: compact ? '0.35s ease' : '3s'
                    }}
                />
            </div>
        </div>
    );

};
export default LinearProgress;